<template>
  <v-flex xs12 class="mb-4">
    <div class style="position: relative;">
      <div class="flex-container-space-between vertical-center-container">
        <page-title :routeProps="routeProps"></page-title>
        <!-- <v-btn flat color="grey" @click="toggleView()">         
                    <v-icon left v-if="listView">list</v-icon>
                    <v-icon left v-else>view_module</v-icon>
                    View
        </v-btn>-->
      </div>
      <!-- <layout-no-padding>
                <v-flex xs12 sm6 md3>
                </v-flex>
                <v-flex xs12 sm6 md3>
                    <v-text-field
                    label="Filter by..."
                    v-model="filterBy"
                    prepend-icon="filter_list"
                    >   
                    </v-text-field>
                </v-flex>
      </layout-no-padding>-->

      <!-- <v-dialog v-model="addTipDialog" max-width="500px" @keydown.esc="addTipDialog = false">
                <v-btn fab dark :color="routeProps.color" class="overlap-fab-tip" slot="activator">
                    <v-icon dark>add</v-icon>
                </v-btn>
                <add-tip @close="addTipDialog = false"></add-tip>
      </v-dialog>-->
      <div
        style="width:100%; height:1px; margin-top: 15px; margin-bottom: 15px;"
        class="grey lighten-1"
      ></div>
      <!-- <card-divider-split></card-divider-split> -->
    </div>
  </v-flex>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
//import TipService from '@/services/requests/tipService'
//import SpoilService from '@/services/requests/spoilService'
///import TipValidation from '@/services/validation/tipValidation'
//import AddTip from '@/components/tips/addTip'
import RouteProps from "@/services/mixins/routeProps";
export default {
  mixins: [
    //TipValidation,
    RouteProps
  ],
  data() {
    return {};
  },
  methods: {
    toggleView() {
      this.listView = !this.listView;
    }
  },
  computed: {
    sortBy: Store.getSet({ store: "tips", prop: "sortBy" }),
    filterBy: Store.getSet({ store: "tips", prop: "filterBy" }),
    listView: Store.getSet({ store: "tips", prop: "listView" })
    //loadingTips: Store.getSet({store: 'tips', prop: 'loadingTips'}),
  },
  mounted() {
    //this.getTips()
    //this.getSpoils()
  },
  destroy() {
    //this.$store.commit("tips/modifyLoadingTips", true);
    //this.$store.commit("tips/resetTips");
  },
  components: {
    //AddTip
  }
};
</script>

<style scoped>
.overlap-fab-tip {
  right: 40px;
  bottom: -17px;
  position: absolute !important;
}
</style>
